// removed by extract-text-webpack-plugin
module.exports = {"ArchiveButton":"OpenArchiveButton__-loca-__9--xR","Disabled":"OpenArchiveButton__-loca-__31bJz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Buttons/OpenArchiveButton/OpenArchiveButton.css
// module id = 235
// module chunks = 0